import { useRouter } from "next/router";
import {
  type Dispatch,
  type FC,
  type SetStateAction,
  useEffect,
  useState,
} from "react";
import { MultiSelect } from "react-multi-select-component";
import Image from "next/image";
import { filterSubCategories } from "./searchUtils";
import { ORDER_TYPE } from "~/utils/constants";
import filter from "@public/icon/ico-filter.svg";
import { type CategoryType } from "~/pages/ricerca";
import { MULTISELECT_OVERRIDE_STRINGS } from "./constants";

type SearchFilterProps = {
  subCategories: CategoryType[];
  categories: CategoryType[];
  onFilter: () => void;
  selectedSources: CategoryType[];
  setSelectedSources: Dispatch<SetStateAction<CategoryType[]>>;
  selectedSubSources: CategoryType[];
  setSelectedSubSources: Dispatch<SetStateAction<CategoryType[]>>;
};

const SearchFilter: FC<SearchFilterProps> = ({
  subCategories,
  categories,
  onFilter,
  selectedSources,
  setSelectedSources,
  selectedSubSources,
  setSelectedSubSources,
}) => {
  const router = useRouter();

  const filteredSubCategories = filterSubCategories(
    selectedSources,
    subCategories
  );

  const [order, setOrder] = useState("");

  useEffect(() => {
    if (router.query.order)
      setOrder(
        router.query.order == ORDER_TYPE.BYRELEVANCE
          ? ORDER_TYPE.BYRELEVANCE
          : ORDER_TYPE.BYDATE
      );
    else setOrder(ORDER_TYPE.BYRELEVANCE);
  }, [router.query.order]);

  const onSourcesChange = (newSelectedSources: CategoryType[]) => {
    const filteredSubSources = selectedSubSources.filter((subSource) =>
      newSelectedSources.find((source) => source.id === subSource.parentId)
    );

    setSelectedSources(newSelectedSources);
    setSelectedSubSources(filteredSubSources);
  };

  const ordina = (valueOrdine: string) => {
    const routerQuery = router.query;
    routerQuery.order = valueOrdine;
    delete routerQuery.page;
    router.push({
      ...router,
      query: routerQuery,
      hash: "risultati",
    });
  };

  return (
    <div className="flex flex-col gap-y-8 lg:flex-row lg:justify-between lg:gap-4">
      <div className="flex flex-col gap-y-2 lg:w-3/5">
        <div className="flex flex-shrink-0 items-center gap-2 md:mr-6">
          <Image width={20} height={20} src={filter} alt="filter" priority />
          <label className="p-2.5 pl-0 text-sm font-extrabold sm:text-base">
            Filtra i risultati
          </label>
        </div>

        <div className="flex flex-col gap-2 sm:flex-row lg:w-11/12">
          <MultiSelect
            options={categories}
            value={selectedSources}
            onChange={onSourcesChange}
            labelledBy="Categoria"
            className="w-full text-sm sm:w-2/5"
            hasSelectAll={false}
            overrideStrings={MULTISELECT_OVERRIDE_STRINGS}
          />
          {selectedSources.length > 0 && filteredSubCategories.length > 0 && (
            <MultiSelect
              options={filteredSubCategories}
              value={selectedSubSources}
              onChange={setSelectedSubSources}
              labelledBy="Sotto Categoria"
              className="w-full text-sm sm:w-2/5"
              hasSelectAll={false}
              overrideStrings={MULTISELECT_OVERRIDE_STRINGS}
            />
          )}
          <button
            className="h-10 w-full border-[1px] border-solid border-orange bg-orange text-sm text-white sm:w-1/5"
            onClick={onFilter}
          >
            {" "}
            Filtra
          </button>
        </div>
      </div>
      <div className="flex flex-col gap-y-2">
        <div className="flex flex-shrink-0 items-center gap-2 md:mr-6">
          <span className="input-ico-sort"></span>
          <label className=" p-2.5 pl-0 text-xs font-extrabold sm:text-base">
            Ordina i risultati
          </label>
        </div>
        <div className="flex h-10 items-center justify-start gap-x-2 border-[1px] border-solid border-gray bg-lightLightGray p-2 text-black sm:justify-center lg:justify-start lg:text-left">
          <input
            type="radio"
            value={ORDER_TYPE.BYRELEVANCE}
            id={ORDER_TYPE.BYRELEVANCE}
            checked={order == ORDER_TYPE.BYRELEVANCE}
            onClick={() => ordina(ORDER_TYPE.BYRELEVANCE)}
          />
          <label className="my-2.5 p-2.5 pl-0 text-xs sm:text-base">
            per rilevanza
          </label>
          <input
            type="radio"
            value={ORDER_TYPE.BYDATE}
            id={ORDER_TYPE.BYDATE}
            checked={order == ORDER_TYPE.BYDATE}
            onClick={() => ordina(ORDER_TYPE.BYDATE)}
          />
          <label className="my-2.5 p-2.5 pl-0 text-sm sm:text-base">
            dal più recente
          </label>
        </div>
      </div>
    </div>
  );
};

export default SearchFilter;
